<template>
	<div>
		<div id="mobile-menu" class="flex items-center lg:hidden min-h-[50px]">
			<div class="px-6 h-full flex items-center justify-center border-r border-gray-300">
				<div @click="mobileIsOpen = ! mobileIsOpen" class="cursor-pointer">
	            	<inline-svg name="menu"></inline-svg>
	            </div>

	            <div v-if="mobileIsOpen">
	            	<div class="absolute top-0 left-0 w-full h-full flex z-50">
	            		<div>
					    	<div class="relative flex items-center justify-center bg-brand w-64 h-20 p-4 text-center border-b-2 border-gray-200 shadow-md">
					        	<img src="/img/logos/reoptimizer-white.png">
					        	<div @click="mobileIsOpen = false" class="-mr-12 mt-5 absolute top-0 right-0 z-50 cursor-pointer">
					        		<inline-svg name="close" classes="p-2 w-10 h-10 flex items-center justify-center text-white fill-current rounded-full hover:bg-black hover:opacity-50"></inline-svg>
					        	</div>
					    	</div>
					    	<div class="py-6 px-5 flex flex-col h-full gap-y-5 bg-white">
								<a v-if="$gate.isAdmin()" class="mt-3 relative flex items-center" :class="{ 'active': rootRoute == 'admin' }" href="/admin">
									<img src="/img/nav/admin.png" class="w-8 h-8" />
									<p class="ml-2 text-lg text-gray-800">Admin</p>
								</a>

								<a class="relative flex items-center" :class="{ 'active': routeName == rootRoute }" :href="row.url" v-for="(row, routeName) in links" :key="routeName">
									<img :src="row.icon" :class="row.classes" />
									<p class="ml-2 text-lg text-gray-800" v-html="row.label"></p>
								</a>
							</div>
	                	</div>
	                	<div @click="mobileIsOpen = false" class="flex-1 bg-black opacity-50 z-40"></div>
	                </div>
	            </div>
	        </div>
		</div>

		<ul class="ml-10 hidden lg:flex flex-1 items-center justify-center gap-x-3">
			<a v-if="$gate.isAdmin()" class="navigation-item relative flex flex-col items-center" :class="{ 'active': rootRoute == 'admin' }" href="/admin">
				<img src="/img/nav/admin.png" class="w-8 h-8" />
				<p class="pt-2 text-sm text-gray-800">Admin</p>
			</a>

			<a class="navigation-item relative flex flex-col items-center" :class="{ 'active': routeName == rootRoute }" :href="row.url" v-for="(row, routeName) in filteredLinks" :key="routeName">
				<img :src="row.icon" :class="row.classes" />
				<p class="pt-2 text-sm text-gray-800" v-html="row.label"></p>
			</a>
		</ul>
	</div>
</template>

<script>
	export default {
	    name: 'ReoptNavigation',

		props: {
			currentRoute: {
				type: String,
				required: true
			}
		},

		data() {
			return {
				mobileIsOpen: false,
				userModules: [],
				links: {
					estimatedWaste: {
						label: 'Waste',
						url: '/estimated-waste',
						icon: '/img/nav/estimated-waste.png',
						classes: "w-8 h-8"
					},

					dashboard: {
						label: 'Dashboard',
						url: '/',
						icon: '/img/nav/dashboard.png',
						classes: "w-8 h-8"
					},

                    reatlas: {
                        label: 'REatlas',
                        url: '/reatlas',
                        icon: '/img/nav/reatlas.png',
                        classes: "w-8 h-8"
                    },

                    // Temporarily hidden - old CRESiteIQ link
                    // cresiteiq: {
                    //     label: 'CRESiteIQ&trade;',
                    //     url: '/cresiteiq',
                    //     icon: '/img/nav/cresiteiq.png',
                    //     classes: "w-8 h-8"
                    // },

                    cresiteiq2: {
                        label: 'CRESiteIQ&trade;',
                        url: '/cresiteiq2',
                        icon: '/img/nav/cresiteiq.png',
                        classes: "w-8 h-8"
                    },

					sites: {
						label: 'Sites',
						url: '/sites',
						icon: '/img/nav/sites.png',
						classes: "w-8 h-8"
					},

					projects: {
						label: 'Projects',
						url: '/projects',
						icon: '/img/nav/projects.png',
						classes: "w-8 h-8"
					},

					tasks: {
						label: 'Tasks',
						url: '/tasks',
						icon: '/img/nav/tasks.png',
						classes: "w-8 h-8"
					},

					// proposals: {
					// 	label: 'Proposals',
					// 	url: '/proposals',
					// 	icon: 'nav/proposals'
					// },

					reports: {
						label: 'Reports',
						url: '/reports',
						icon: '/img/nav/reports.png',
						classes: "w-8 h-8"
					},

					documents: {
						label: 'Documents',
						url: '/documents',
						icon: '/img/nav/documents.png',
						classes: "w-8 h-8"
					},

					legalAiFiles: {
						label: 'AI Tools',
						url: '/lease-ai-files',
						icon: '/img/nav/lease-ai.png',
						classes: "w-8 h-8"
					},

					listingSearch: {
						label: 'Listing Search',
						url: '/listing-search',
						icon: '/img/nav/lease-ai.png',
						classes: "w-8 h-8"
					},

					// calendar: {
					// 	label: 'Calendar',
					// 	url: '/calendar',
					// 	icon: '/img/nav/calendar.png',
					// classes: "w-8 h-8"
					// },

					// help: {
					// 	label: 'Help',
					// 	url: '/help',
					// 	icon: '/img/nav/help.png',
					// classes: "w-8 h-8"`
					// }
					// planModules: {
					// 	label: 'Access Modules',
					// 	url: '/admin/access-modules',
					// 	icon: '/img/nav/plan-module.png',
					// 	classes: "w-8 h-8",
					// 	adminOnly: true
					// },
				}
			}
		},

		methods: {
			processModulePermissions() {
				if (!window.user || !window.user.module_permissions) {
					this.userModules = [];
					return;
				}
				
				// module_permissions structure: { moduleId: { enabled: bool, slug: string } }
				this.userModules = Object.entries(window.user.module_permissions).map(([moduleId, module]) => ({
					id: parseInt(moduleId),
					slug: module.slug,
					enabled: module.enabled === true
				}));
				
				console.log('Navigation - Processed modules:', this.userModules);
			},
			
			toggleMobileMenu() {
				this.mobileIsOpen = !this.mobileIsOpen;
			}
		},

		created() {
			this.processModulePermissions();
			
			// Watch for changes to window.user
			if (window.user) {
				this.processModulePermissions();
			} else {
				const checkUser = setInterval(() => {
					if (window.user) {
						clearInterval(checkUser);
						this.processModulePermissions();
					}
				}, 100);
			}
		},

		computed: {
			rootRoute() {
				return this.currentRoute.split('.')[0];
			},
			
			// Get user's module permissions from window.user
			userModulePermissions() {
				if (!window.user || !window.user.module_permissions) {
					return [];
				}
				return Object.values(window.user.module_permissions);
			},
			filteredLinks() {
				// Debug logging
				console.log('Navigation - User:', window.user);
				console.log('Navigation - $gate:', this.$gate);
				console.log('Navigation - isToolboxUser:', this.$gate?.isToolboxUser?.());
				
				// Special case: Toolbox users see only Toolbox
				if (this.$gate && this.$gate.isToolboxUser && this.$gate.isToolboxUser()) {
					console.log('Navigation - Returning toolbox menu only');
					return {
						toolbox: {
							label: 'Toolbox',
							url: '/toolbox',
							icon: '/img/nav/dashboard.png',
							classes: "w-8 h-8"
						}
					};
				}
				
				const links = {...this.links};
				
				// If user is admin, show all links including Toolbox
				if (this.$gate?.isAdmin()) {
					// Add Toolbox to admin menu
					links.toolbox = {
						label: 'Toolbox',
						url: '/toolbox',
						icon: '/img/nav/dashboard.png',
						classes: "w-8 h-8"
					};
					return links;
				}

				// Brokers see dashboard, sites, and projects
				if (this.$gate?.isBroker()) {
					const brokerLinks = {
						dashboard: links.dashboard,
						sites: links.sites,
						projects: links.projects
					};
					
					// Check if broker has Toolbox module enabled
					const hasToolboxAccess = this.userModules.some(module => 
						module.slug === 'toolbox' && module.enabled
					);
					
					if (hasToolboxAccess) {
						brokerLinks.toolbox = {
							label: 'Toolbox',
							url: '/toolbox',
							icon: '/img/nav/dashboard.png',
							classes: "w-8 h-8"
						};
					}
					
					return brokerLinks;
				}

				// For non-admin users
				if (this.$gate?.isClientUser()) {
					// For client_user, apply module permission filtering
					const filtered = {};
					
					// Always include dashboard
					if (links.dashboard) {
						filtered.dashboard = links.dashboard;
					}
					
					// Filter other links based on module permissions
					Object.entries(links).forEach(([key, link]) => {
						// Skip dashboard (already included) or admin-only links
						if (key === 'dashboard' || link.adminOnly) {
							return;
						}
						
						// Check if user has access to this module (using the key as the module identifier)
						const hasAccess = this.userModules.some(module => 
							module.slug === key && module.enabled
						);
						
						if (hasAccess) {
							filtered[key] = link;
						}
					});
					
					// Check if user has Toolbox module enabled
					const hasToolboxAccess = this.userModules.some(module => 
						module.slug === 'toolbox' && module.enabled
					);
					
					if (hasToolboxAccess) {
						filtered.toolbox = {
							label: 'Toolbox',
							url: '/toolbox',
							icon: '/img/nav/dashboard.png',
							classes: "w-8 h-8"
						};
					}
					
					return filtered;
				}
				
				// For all other non-admin roles, show all non-admin links
				return Object.fromEntries(
					Object.entries(links).filter(([_, link]) => !link.adminOnly)
				);
			}
		}
	}
</script>
